<template>
    <div class="">
      子菜单2
    </div>
</template>

<script>
export default {
    data() {
        return {}
    },
    mounted() {
        
    },
    methods: {
        
    },
}
</script>

<style scoped>

</style>
